import { BootstrapConfig } from 'core/type/BootstrapConfig.types';
import { MeasurementName } from 'core/constant/MeasurementName';
import { IMeasurementTags } from '@agoda/messaging-client';
import { buildMeasurement } from 'core/service/measurements/measurementUtils';
import { logInfo, logWarn } from 'core-framework/util/LogMessage';
import { sendMeasurement } from 'core/messaging/measurement/measurement';
import { ActivitiesPageTypes } from 'core/constant/analytics/AnalyticsPageType';
import { MeasurementStatus } from 'core/constant/MeasurementStatus';
import { LandingLink } from 'core/type/LandingLink.types';

const sendLandingLinkApiMeasurements = (
    message: string,
    measurementName: MeasurementName,
    pageTypeId: ActivitiesPageTypes,
    config: BootstrapConfig,
    tags: IMeasurementTags,
): boolean => {
    const measurement = buildMeasurement('generateShortenUrl', measurementName, pageTypeId, message, 1, false, config);
    measurement.tags = {
        ...measurement.tags,
        ...tags,
    };
    sendMeasurement({ ...measurement, name: MeasurementName.LandingLinkApiStatus }, pageTypeId);

    if (measurementName === MeasurementName.LandingLinkApiSuccess) {
        logInfo(message, pageTypeId, measurement.tags);
        return true;
    }
    logWarn(message, pageTypeId, measurement.tags);
    return true;
};
export const measureLandingLinkApiResponse = (response: LandingLink, pageTypeId: ActivitiesPageTypes, config: BootstrapConfig): boolean => {
    const measurementTags: IMeasurementTags = {
        statusCode: response.status === 'error' ? '500' : '200',
    };

    if (response.status === 'success') {
        measurementTags.status = MeasurementStatus.Success;
        if (!response || response.shortenUrl === '' || response.shortenUrl === null) {
            return sendLandingLinkApiMeasurements('no_results', MeasurementName.LandingLinkApiNoResult, pageTypeId, config, measurementTags);
        }
        return sendLandingLinkApiMeasurements(response.status, MeasurementName.LandingLinkApiSuccess, pageTypeId, config, measurementTags);
    }

    measurementTags.status = MeasurementStatus.Failed;
    return sendLandingLinkApiMeasurements(response.status, MeasurementName.LandingLinkApiError, pageTypeId, config, measurementTags);
};
